let setBrandingLink: (tenantId: string | null) => void = (tenantId: string | null) => {
	const brandingLink = document.getElementById("branding") as HTMLLinkElement
	if (tenantId) {
		if (brandingLink) {
			brandingLink.href = process.env.VUE_APP_HTTP_API_URI + "tenant/css?tenant=" + tenantId
		} else {
			const link = document.createElement("link")
			link.id = "branding"
			link.rel = "stylesheet"
			link.href = process.env.VUE_APP_HTTP_API_URI + "tenant/css?tenant=" + tenantId
			document.head.appendChild(link)
		}
	} else {
		if (brandingLink) {
			brandingLink.remove()
		}
	}
}

export default setBrandingLink
